export default __webpack_public_path__ + "static/media/Culture.dd9dcee8.jpg";